// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"26":"5e3bb01336964912","190":"73c4d721aacf580d","620":"b2ed4ba267c706c1","974":"dd2ce6577a4a7709","990":"999529b806e21c69"}[chunkId] + ".js";
};